import React from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import MobileOptionsMenu from '../MobileOptionsMenu';

const DataCollectorMobileOptionsMenu = ({record, ...props}) => {
    const localizedStrings = getLocalizedStrings();

    return (
        <MobileOptionsMenu
            {...props}
            label={localizedStrings.formatString(
                localizedStrings[localizationKeys.DC_PAGE_MOBILE_ACTIONS],
                record?.model || record?.deviceNumber || ''
            )}
            triggerClassName='data-collector-actions-trigger'
            overlayClassName='data-collector-actions-menu'
        />
    );
};

export default DataCollectorMobileOptionsMenu;
